import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";

import {
  UserCommissionReport,
  UpdateCommissionStatus,
} from "../../Server/api";

function PendingUserCommReport() {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [mobile, setMobile] = useState("");
  const [totalCommission, setTotalCommission] = useState(0);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [tempStartDate, setTempStartDate] = useState("");
const [tempEndDate, setTempEndDate] = useState("");
const [tempMobile, setTempMobile] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const [reason, setReason] = useState("");
const [filterTrigger, setFilterTrigger] = useState(false);
  const [showFilter, setShowFilter] = useState(true);
  const [selectedIds, setSelectedIds] = useState([]);
  const getCommissionReport = async () => {
    try {
      const payload = {
        page,
        limit,
        mobile,
        from_date: startDate,
        to_date: endDate,
      };
      const res = await UserCommissionReport(payload);
      setRows(res?.data?.data || []);
      setTotalCommission(res?.data?.total_commission || 0);
    } catch (error) {
      console.log("API ERROR", error);
    }
  };
  const handleSubmit = async () => {
    try {
      if (actionType === "reject" && !reason) {
        alert("Please enter reject reason");
        return;
      }
      const payload = {
        report_ids: selectedIds,
        status:
          actionType === "approve"
            ? "success"
            : "rejected",
        reject_remark: reason,
      };

      console.log("FINAL PAYLOAD", payload);

      const res =
        await UpdateCommissionStatus(payload);

      console.log(
        "STATUS UPDATE RESPONSE",
        res?.data
      );

      alert(
        res?.data?.message ||
        "Status Updated Successfully"
      );

      // REFRESH DATA
      getCommissionReport();

      // RESET
      setShowModal(false);
      setReason("");
      setActionType("");
      setSelectedIds([]);

    } catch (error) {
      console.log(
        "STATUS UPDATE ERROR",
        error
      );
    }
  };
  const handleSelectAll = (checked) => {

    if (checked) {
      const allIds = rows.map((item) => item._id);
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };
  const handleCheckbox = (id, checked) => {
    if (checked) {
      setSelectedIds((prev) => [...prev, id]);
    } else {
      setSelectedIds((prev) =>
        prev.filter((item) => item !== id)
      );
    }
  };
// useEffect(() => {
//   getCommissionReport();
// }, [page, limit, startDate, endDate, mobile]);

useEffect(() => {
  getCommissionReport();
}, [page, limit, filterTrigger]);
const handleFilter = () => {
  setPage(1);
  setFilterTrigger((prev) => !prev);
};
const handleReset = () => {
  setPage(1);

  setStartDate("");
  setEndDate("");
  setMobile("");

  setFilterTrigger((prev) => !prev);
};




  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header bg-color-black">
            <div className="d-flex align-items-center justify-content-between">
              <h3 className="card-title text-white mb-0">
               Pending User Commission List
              </h3>
              <div className="d-flex flex-wrap align-items-center gap-2">
                {/* <button
                  className="backbutton"
                  onClick={() => navigate(-1)}
                >
                  <BsArrowLeft className="me-1" />
                  filter
                </button> */}
                <button
                  className="backbutton"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <BsArrowLeft className="me-1" />
                  {showFilter ? "Close Filter" : "Open Filter"}
                </button>
                <button
                  className="btn btn-success"
                  onClick={() => {
                    if (selectedIds.length === 0) {
                      alert("Please select atleast one row");
                      return;
                    }
                    setActionType("approve");
                    setShowModal(true);
                  }}
                >
                  Approve
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    if (selectedIds.length === 0) {
                      alert("Please select atleast one row");
                      return;
                    }

                    setActionType("reject");
                    setShowModal(true);
                  }}
                >
                  Reject
                </button>

              </div>
            </div>
          </div>

          <div className="card-body">
            {showFilter && (
              <div className="row mb-4">
                <div className="col-md-4">
                  <label>Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => {
                      setPage(1);
                      setStartDate(e.target.value);
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <label>End Date</label>

                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => {
                      setPage(1);
                      setEndDate(e.target.value);
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <label>Mobile</label>
                  <input
                    type="text"
                    placeholder="Search mobile..."
                    className="form-control"
                    value={mobile}
                    onChange={(e) => {
                      setPage(1);
                      setMobile(e.target.value);
                    }}
                  />
                </div>
                <div className="col-md-12 mt-3 d-flex gap-2">

  <button
    className="btn btn-primary"
    onClick={handleFilter}
  >
    Filter
  </button>

  <button
    className="btn btn-secondary"
    onClick={handleReset}
  >
    Reset
  </button>

</div>
              </div>
            )}

            <div className="row">
              <h5 className="mb-0">
                <p>Total Commission: ₹ {totalCommission.toFixed(2)}</p>
              </h5>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        checked={
                          rows.length > 0 &&
                          selectedIds.length === rows.length
                        }
                        onChange={(e) =>
                          handleSelectAll(e.target.checked)
                        }
                      />
                    </th>
                    <th>DATE</th>
                    <th>MOBILE</th>
                    <th>Win Amount</th>
                    <th>Loss Amount</th>
                    <th>Amount</th>
                    <th>Commission Amount</th>
                    <th>STATUS</th>
                    <th>REMARK</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.length === 0 ? (
                    <tr>
                      <td
                        colSpan="6"
                        className="py-5"
                      >
                        <strong>No Data</strong>
                      </td>
                    </tr>
                  ) : (
                    rows.map((r, i) => (
                      <tr key={i}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedIds.includes(
                              r?._id
                            )}
                            onChange={(e) =>
                              handleCheckbox(
                                r?._id,
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          {new Date(
                            r?.created_at
                          ).toLocaleDateString()}
                        </td>
                        <td>{r?.mobile}</td>
                        <td>
                          ₹ {r?.total_win}
                        </td>
                        <td>
                          {r?.total_loss}
                        </td>
                        <td>
                          {r?.remaining_loss}
                        </td>
                        <td>
                          {r?.com_amount}
                        </td>
                          <td>
                          <span
                            className={`badge ${r?.tr_status ===
                              "success"
                              ? "bg-success"
                              : r?.tr_status ===
                                "rejected"
                                ? "bg-danger"
                                : "bg-warning"
                              }`}
                          >
                            {r?.tr_status}
                          </span>
                        </td>
                        <td>{r?.remark}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between mt-3">
              <div>
                <select
                  value={limit}
                  onChange={(e) => {
                    setLimit(
                      Number(e.target.value)
                    );
                    setPage(1);
                  }}
                  className="form-select w-auto"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                </select>
              </div>
              <div className="paginationall">
                <button
                  disabled={page === 1}
                  onClick={() =>
                    setPage((p) => p - 1)
                  }
                  className="pagination_button"
                >
                  <MdOutlineKeyboardArrowLeft />
                </button>
                <button
                  disabled={rows.length < limit}
                  onClick={() =>
                    setPage((p) => p + 1)
                  }
                  className="pagination_button"
                >
                  <MdOutlineKeyboardArrowRight />
                </button>

              </div>
            </div>

          </div>
        </div>
      </div>
      {showModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.5)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-capitalize">
                  {actionType} Commission
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowModal(false);
                    setReason("");
                  }}
                ></button>
              </div>
              <div className="modal-body">
                {actionType ===
                  "approve" ? (
                  <p>
                    Are you sure you want
                    to approve selected
                    commissions?
                  </p>
                ) : (
                  <>
                    <label className="mb-2">
                      Reject Reason
                    </label>
                    <textarea
                      className="form-control"
                      rows="4"
                      placeholder="Enter reject reason..."
                      value={reason}
                      onChange={(e) =>
                        setReason(
                          e.target.value
                        )
                      }
                    />
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowModal(false);
                    setReason("");
                  }}
                >
                  Cancel
                </button>
                <button
                  className={`btn ${actionType ===
                    "approve"
                    ? "btn-success"
                    : "btn-danger"
                    }`}
                  onClick={handleSubmit}
                >
                  Confirm {actionType}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PendingUserCommReport;